import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { buildEndpoint } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';

const useContractTemplateService = () => {
    const { doGet, doPost } = useFetch();
    
    const [fetchingAll, setFetchingAll] = useState(false);
    const [fetchingStore, setFetchingStore] = useState(false);
    const [fetchingDelete, setFetchingDelete] = useState(false);
    
    const getAllTemplates = (contractTypeId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/contract-types/${contractTypeId}/templates`),
            setFetching: setFetchingAll
        });
    };
    
    const storeTemplate = (data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint('app/contract-drafting/admin/templates/store'),
            body: data,
            setFetching: setFetchingStore
        });
    };
    
    const deleteTemplate = (id: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/templates/${id}/delete`),
            setFetching: setFetchingDelete
        });
    };
    
    return {
        fetchingAll,
        fetchingStore,
        fetchingDelete,
        getAllTemplates,
        storeTemplate,
        deleteTemplate
    };
};

export default useContractTemplateService;

